/**
 * ワークフロー専用mixin
 */
import { getAction } from '@/api/manage'
import CommentModal from '@/views/k00/k0011/modules/CommentModal'

export const flowMixin = {
  data() {
    return {
      isHrPage: false,
      summaryVisible: '',
      summaryInfo: {},
      url: {
        confirm: '/flow/task/confirm',
        appoint: '/flow/processInstance/appoint'
      }
    }
  },
  components: {
    CommentModal
  },
  mounted() {
    var path = this.$route.path.toLowerCase()
    if (
      // 一时保存因为有摘要栏所以无需表示tooltip
      path.indexOf('TemporaryManage'.toLowerCase()) > 0 ||
      // 再利用因为有摘要栏所以无需表示tooltip
      path.indexOf('ApplyManage'.toLowerCase()) > 0
    ) {
      this.isHrPage = true
    }
  },
  computed: {
    showSummaryTooltip() {}
  },
  methods: {
    renderWrapHeader(value) {
      return {
        class: 'tb-header-force-wrap' + ' ' + 'tb-header-force-wrap-' + value.key
      }
    },
    renderApplyNameHeader(value, record, index) {
      return (
        <span>
          <span>流程名称</span>
          <JSlash></JSlash>
          <span>摘要</span>
        </span>
      )
    },
    renderApplyName(value, record, index) {
      if (XEUtils.trim(record.summary)) {
        return (
          <span>
            <span>{value}</span>
            <div class="extraNote" style="white-space: pre-wrap;">
              {record.summary}
            </div>
          </span>
        )
      } else {
        return <span>{value}</span>
      }
    },
    renderStarter(value, record, index) {
      //return (
      //  <span>
      //    <span>{record.starterName}</span>
      //    <span class="extraNote">{record.starterUsername}</span>
      //  </span>
      //)
      return (
        <a-popover trigger="hover" placement="topRight" title={record.starterName}>
          <template slot="content">
            <div class="a-popover-user-info" style="margin-top: -5px; margin-bottom: -5px">
              <p>
                <a-icon type="idcard" theme="twoTone" twoToneColor="#52c41a" />
                <span>{record.starterUsername}</span>
              </p>
              <p>
                <a-icon type="phone" theme="twoTone" twoToneColor="#52c41a" />
                <span>{record.starterPhone}</span>
              </p>
              <p>
                <a-icon type="mail" theme="twoTone" twoToneColor="#52c41a" />
                <span>{record.starterEmail}</span>
              </p>
            </div>
          </template>
          <a-tag color="green">{record.starterName}</a-tag>
        </a-popover>
      )
    },
    renderDepartName(value, record, index) {
      if (value && value.indexOf('上海经度') >= 0) {
        return <div style="white-space: nowrap;">上海经度</div>
      } else {
        return <div style="white-space: nowrap;">{value}</div>
      }
    },
    renderDate(value, record, index) {
      return (
        <span>
          <span style="white-space: nowrap">{moment(value).format('YYYY-MM-DD')}</span>
          {/*<br></br>*/}
          <span class="extraNote">{moment(value).format('HH:mm:ss')}</span>
        </span>
      )
    },
    renderProcessInstanceId(value, record, index) {
      if ((record.processInstanceId || record.procInstId || record.applyNo) != '0') {
        return (
          <a onClick={() => this.handleOpen(record)}>
            {record.processInstanceId || record.procInstId || record.applyNo}
          </a>
        )
      } else {
        return <JEmpty></JEmpty>
      }
    },
    renderSummary(value, record, index) {
      if (record.summary) {
        return Object.keys(record.summary).map(item => {
          if (record.summary[item]) {
            return (
              <div class="div-summary" title={record.summary[item]}>
                <span class="div-summary-title">{this.$t(item) + '：'}</span>
                <span class="div-summary-content">{record.summary[item]}</span>
              </div>
            )
          } else {
            return null
          }
        })
      } else {
        return null
      }
    },
    // ApplyModalを開く
    handleOpen: function(record) {
      var procInstId = record.processInstanceId || record.procInstId || record.applyNo

      if (procInstId) {
        if (this.url.getCount) {
          // 業務情報チェック
          getAction(this.url.getCount, { procInstId: procInstId }).then(res => {
            if (res.success && res.result > 0) {
              this.excuteOpen(procInstId)
            }
          })
        } else {
          this.excuteOpen(procInstId)
        }
      }
    },
    excuteOpen: function(procInstId) {
      this.$refs.ApplyModal.procInstId = procInstId
      this.$refs.ApplyModal.isHrPage = this.isHrPage
      this.$refs.ApplyModal.handleOpen()
    },
    // batchType ➡ 0:未処理一覧 1:処理済一覧 2:一時保存 3:申請案件の未処理タブ 4:申請案件の非活性タブ 5:事務系画面
    batchAction: function(key, batchType) {
      if (this.selectedRowKeys.length <= 0) {
        this.$message.warning(this.$t('disp.rules.select'))
        return false
      }

      let arr = []
      switch (key) {
        //************************************
        // 一括承認(未処理一覧、事務系画面)
        //************************************
        case 'approve':
          arr = []

          // 事務系
          if (batchType == '5') {
            // CommentModalにて承認可能かをチェックする
            this.selectionRows.forEach(val => {
              val.processInstanceId = val.processInstanceId || val.procInstId || val.applyNo
              arr.push(val)
            })
          }
          // 未処理一覧
          else {
            this.selectionRows.forEach(val => {
              if (val.taskStatus == 'disp.flow.approveWait' && !val.keepFlag && val.batchConfirmFlag) {
                arr.push(val)
              }
            })
          }
          if (arr.length == 0) {
            this.$message.warning(this.$t('msg.flow.confirm.batch', [this.$t('disp.flow.approveBatch')]))
            return true
          }
          this.$refs.CommentModal.handleOpen(
            this.$t('disp.flow.approveBatch'),
            arr,
            this.url.confirm,
            this.$t('msg.flow.confirm.approveBatch'),
            false,
            batchType == '5' ? true : false
          )
          return true

        //************************************
        // 批量委派(未処理一覧)
        //************************************
        case 'appoint':
          arr = []
          this.selectionRows.forEach(val => {
            if (val.taskStatus == 'disp.flow.approveWait' && !val.keepFlag) {
              arr.push(val)
            }
          })
          if (arr.length == 0) {
            this.$message.warning(this.$t('msg.flow.confirm.batch', ['批量委派']))
            return true
          }
          this.$refs.CommentModal.handleOpen(
            '批量委派',
            arr,
            this.url.appoint,
            '请确定是否委派？不符合条件的数据将会被跳过。',
            false
          )
          return true

        //************************************
        // 一括却下(未処理一覧)
        //************************************
        case 'refuse':
          arr = []
          this.selectionRows.forEach(val => {
            if (val.taskStatus == 'disp.flow.approveWait' && !val.keepFlag) {
              arr.push(val)
            }
          })
          if (arr.length == 0) {
            this.$message.warning(this.$t('msg.flow.confirm.batch', [this.$t('disp.flow.refuseBatch')]))
            return true
          }
          this.$refs.CommentModal.handleOpen(
            this.$t('disp.flow.refuseBatch'),
            arr,
            this.url.refuse,
            this.$t('msg.flow.confirm.refuseBatch'),
            true
          )
          return true

        //************************************
        // 一括取消(未処理一覧、一時保存一覧、処理済一覧、申請案件一覧)
        //************************************
        case 'cancel':
          arr = []
          this.selectionRows.forEach(val => {
            // 未処理一覧、一時保存一覧
            if (batchType == '0' || batchType == '2') {
              if ((val.taskStatus == 'disp.flow.save' || val.taskStatus == 'disp.flow.applyWait') && !val.keepFlag) {
                arr.push(val)
              }
            }
            // 処理済一覧
            if (batchType == '1') {
              if (val.cancelFlag && !val.keepFlag && !val.freezeFlag) {
                arr.push(val)
              }
            }
            // 申請案件一覧(進行中案件・非活性案件)
            if (batchType == '3' || batchType == '4') {
              if (!val.keepFlag && !val.freezeFlag) {
                arr.push(val)
              }
            }
          })
          if (arr.length == 0) {
            this.$message.warning(this.$t('msg.flow.confirm.batch', [this.$t('disp.flow.cancelBatch')]))
            return true
          }
          this.$refs.CommentModal.handleOpen(
            this.$t('disp.flow.cancelBatch'),
            arr,
            this.url.cancel,
            this.$t('msg.flow.confirm.cancelBatch')
          )
          return true

        //************************************
        // 一括保留(未処理一覧)
        //************************************
        case 'keep':
          arr = []
          this.selectionRows.forEach(val => {
            if (
              val.parallelFlag == false &&
              val.paralleltask == false &&
              val.candidateUsers.length > 1 &&
              !val.keepFlag
            ) {
              arr.push(val)
            }
          })
          if (arr.length == 0) {
            this.$message.warning(this.$t('msg.flow.confirm.batch', [this.$t('disp.flow.keepBatch')]))
            return true
          }
          this.$refs.CommentModal.handleOpen(
            this.$t('disp.flow.keepBatch'),
            arr,
            this.url.keep,
            this.$t('msg.flow.confirm.keepBatch')
          )
          return true

        //************************************
        // 一括保留取消(未処理一覧、申請案件一覧)
        //************************************
        case 'keepCancel':
          arr = []
          this.selectionRows.forEach(val => {
            if (val.keepFlag) {
              arr.push(val)
            }
          })
          if (arr.length == 0) {
            this.$message.warning(this.$t('msg.flow.confirm.batch', [this.$t('disp.flow.keepCancelBatch')]))
            return true
          }
          // 一括保留取消
          this.$refs.CommentModal.handleOpen(
            this.$t('disp.flow.keepCancelBatch'),
            arr,
            this.url.cancelkeep,
            this.$t('msg.flow.confirm.keepCancelBatch')
          )
          return true

        //************************************
        // 一括凍結(申請案件一覧)
        //************************************
        case 'freeze':
          arr = []
          this.selectionRows.forEach(val => {
            if (!val.keepFlag && !val.freezeFlag) {
              arr.push(val)
            }
          })
          if (arr.length == 0) {
            this.$message.warning(this.$t('msg.flow.confirm.batch', [this.$t('disp.btn.frozenBatch')]))
            return true
          }
          this.$refs.CommentModal.handleOpen(
            this.$t('disp.btn.frozenBatch'),
            arr,
            this.url.freeze,
            this.$t('msg.W_K0014002_04')
          )
          return true

        //************************************
        // 一括解凍(申請案件一覧)
        //************************************
        case 'unfreeze':
          // 解凍処理データの再編集
          arr = []
          this.selectionRows.forEach(val => {
            if (val.freezeFlag) {
              arr.push(val)
            }
          })
          if (arr.length == 0) {
            this.$message.warning(this.$t('msg.flow.confirm.batch', [this.$t('disp.btn.unFrozenBatch')]))
            return true
          }
          // 一括解凍
          this.$refs.CommentModal.handleOpen(
            this.$t('disp.btn.unFrozenBatch'),
            arr,
            this.url.unfreeze,
            this.$t('msg.W_K0014002_06')
          )
          return true

        //************************************
        // 一括引戻(処理済一覧)
        //************************************
        case 'pullback':
          arr = []
          this.selectionRows.forEach(val => {
            if (val.pullBackFlag) {
              arr.push(val)
            }
          })
          if (arr.length == 0) {
            this.$message.warning(this.$t('msg.flow.confirm.batch', [this.$t('disp.flow.pullbackBatch')]))
            return true
          }
          // 一括引戻
          this.$refs.CommentModal.handleOpen(
            this.$t('disp.flow.pullbackBatch'),
            arr,
            this.url.pullback,
            this.$t('msg.flow.confirm.pullbackBatch')
          )
          return true

        //************************************
        // 一括処理者追加(申請案件一覧(非活性案件))
        //************************************
        case 'candidateAdd':
          arr = []
          this.selectionRows.forEach(val => {
            if (!val.freezeFlag) {
              arr.push(val)
            }
          })
          if (arr.length == 0) {
            this.$message.warning(this.$t('msg.flow.confirm.batch', [this.$t('disp.flow.candidateAddBatch')]))
            return true
          }

          this.isBatchAction = true
          this.$refs.selectUserTreeModal.params.multiFlg = '1'
          this.$refs.selectUserTreeModal.params.departFlg = '1'
          this.$refs.selectUserTreeModal.params.selectUserList = this.selectUserList
          this.$refs.selectUserTreeModal.loadDepart()
          this.$refs.selectUserTreeModal.visible = true
          return true

        default:
          return false
      }
    }
  }
}

